import { TestChart } from '../components/TestChart';
import { TestInteractiveChart } from '../components/TestInteractiveChart';

import { useState } from 'react';
import { Dropzone } from '../../ocr/components/Dropzone';
import { MockedCards } from '../components/MockedCards';
type Sections = 'Charts' | 'Dropzone' | 'MenuCards';
export default function TestPage() {
  const [section, setSection] = useState<Sections>('Charts');

  const handleSectionChange = (value: Sections) => {
    setSection(value);
  };

  const renderSection = () => {
    if (section === 'Charts') {
      return (
        <>
          <TestChart />
          <TestInteractiveChart />
        </>
      );
    } else if (section === 'Dropzone') {
      return <Dropzone />;
    } else if (section === 'MenuCards') {
      return <MockedCards />;
    }
  };
  return (
    <div className='flex flex-col justify-center items-center bg-secondary h-screen py-8'>
      {/* <Card className='max-w-lg h-full w-full'>
        <CardHeader>
          <CardTitle>{section}</CardTitle>
          <Select value={section} onValueChange={handleSectionChange}>
            <SelectTrigger>
              <SelectValue placeholder='Select a section' />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value='Charts'>Charts</SelectItem>
              <SelectItem value='Dropzone'>Dropzone</SelectItem>
              <SelectItem value='MenuCards'>MenuCards</SelectItem>
            </SelectContent>
          </Select>
        </CardHeader>
        <CardContent className='flex flex-col gap-8 h-full overflow-auto w-full'>
          {renderSection()}
        </CardContent>
      </Card> */}
    </div>
  );
}
